<template>
  <div class="template-connected">
    <div id="container" class="no-padding">
      <div class="maintenance">
        <div class="page-content">
          <div class="page-single-content">
            <b-img
              src="../img/macs-big-transparent.png"
              class="img-login"
              alt="Logo MACS"
              style="width: 25% !important"
            ></b-img>
            <b-img
              src="../img/maintenance.png"
              class="img-login"
              alt="Maintenance en cours"
            ></b-img>
            <h1>Maintenance en cours</h1>
            <p>Nous sommes en maintenance, nous vous invitons à vous connecter ultérieurement</p>
            <p v-if="canManageMaintenance" class="mt-4">
              <router-link to="/maintenance-management" class="btn btn-outline-primary">
                Accéder à la gestion du mode maintenance
              </router-link>
            </p>
            <p v-if="isAuthenticated" class="mt-3">
              <b-button variant="outline-secondary" @click="logout">
                <font-awesome-icon icon="door-closed" class="mr-2"></font-awesome-icon>
                Déconnexion
              </b-button>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vuex from "vuex";

export default {
  name: "Maintenance",
  methods: {
    ...Vuex.mapActions("Authentification", ["logout"]),
  },
  computed: {
    ...Vuex.mapGetters("Authentification", ["userConnected", "isAuthenticated"]),
    canManageMaintenance() {
      const u = this.userConnected;
      return (
        u &&
        u.roles &&
        u.roles.indexOf("ROLE_SUPER_ADMIN") !== -1
      );
    },
  },
};
</script>

<style></style>
